import React from 'react'
import "./../element.css";
export default function PrivacyPolicy() {
  return (
    <div className="about-us">
      <h1>Privacy Policy</h1>
      <p><strong>WalkNow</strong> ("we", "our", "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our platform.</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Personal:</strong> Name, email, phone, location, resume</li>
        <li><strong>Technical:</strong> IP address, browser, access times</li>
      </ul>

      <h2>2. Use of Information</h2>
      <ul>
        <li>Provide and improve services</li>
        <li>Match job seekers with listings</li>
        <li>Communicate with users</li>
      </ul>

      <h2>3. Sharing</h2>
      <ul>
        <li>Employers, service providers, legal authorities</li>
        <li>No selling of personal data</li>
      </ul>

      <h2>4. User Rights</h2>
      <ul>
        <li>Update or delete account</li>
        <li>Opt-out of marketing</li>
      </ul>

      <h2>5. Security</h2>
      <p>Reasonable measures are taken to secure data</p>

      <h2>6. Children's Privacy</h2>
      <p>Not intended for users under 16</p>

      <h2>7. Changes</h2>
      <p>Updates will be posted here</p>

      <h2>8. Contact</h2>
      <p>Email: <a href="mailto:ram1711sai@gmail.com">ram1711sai@gmail.com</a></p>
    </div>
  )
}
